<template>
  <div class="lantern" v-if="items.length > 0">
    <transition-group name="lantern__fade" tag="ul" class="lantern__items">
      <li class="lantern__item" v-for="item in items" :key="item.guid">
        <a class="lantern__link" :href="item.canonical_url">
          <div class="lantern__media">
            <div class="lantern__bg">
              <img class="lantern__image" @error="error"
                v-if="item.related_items.lead_assets && item.related_items.lead_assets[0].fields && item.related_items.lead_assets[0].fields.binary"
                :src="item.related_items.lead_assets[0].fields.binary.representations.featureAlternates.frontpage_one_third">
              <img class="lantern__image" @error="error"
                v-else-if="item.related_items.lead_assets && item.related_items.lead_assets[0].field && item.related_items.lead_assets[0].fields.poster_url"
                :src="item.related_items.lead_assets[0].fields.poster_url.value">
              <img v-else-if="placeholderImage !== ''" class="lantern__image" :src="placeholderImage">
              <div v-else class="lantern__no-image"></div>
            </div>
          </div>
          <h3 class="lantern__title">{{item.title}}</h3>
          <div class="lantern__lead" v-if="item.fields.lead_text" v-html="item.fields.lead_text.value"></div>
          <div class="lantern__paid" v-if="isPaid(item) || item.publication.name !== 'd2'">
            <badge :type="item.publication.name" :plus="isPaid(item)"></badge>
          </div>
        </a>
      </li>
    </transition-group>

    <div class="lantern__loading" v-if="loading">
      <loading></loading>
    </div>

    <div class="lantern__paginate" v-if="hasNext && paging && !loading">
      <button class="lantern__load" @click="paginate">Last flere</button>
    </div>
  </div>
</template>

<script>
  import { v4 as uuid } from 'uuid';
  import Badge from '@/components/dn/Badge';
  import Loading from '@/components/modules/Loading';
  import Lantern from '@/store/modules/lantern';

  export default {
    props: {
      url: {
        required: true,
      },
      paging: {
        required: false,
        default: true,
      },
      placeholderImage: {
        required: false,
        default: '',
      }
    },
    components: {
      Loading,
      Badge,
    },
    data() {
      return {
        id: uuid(),
      };
    },
    methods: {
      paginate() {
        this.$store.dispatch(`Lantern/${this.id}/next`);
      },
      error(e) {
        let item = e.path[0];
        item.parentNode.removeChild(item);
      },
      isPaid(item) {
        return typeof item.fields.paid !== 'undefined' && item.fields.paid.value !== 'false';
      },
    },
    computed: {
      loading() {
        return this.$store.getters[`Lantern/${this.id}/getLoading`];
      },
      items() {
        return this.$store.getters[`Lantern/${this.id}/getItems`];
      },
      hasNext() {
        return this.$store.getters[`Lantern/${this.id}/hasNext`];
      },
    },
    beforeMount() {
      this.$store.registerModule(`Lantern/${this.id}`, Lantern);
      this.$store.dispatch(`Lantern/${this.id}/fetch`, this.url);
    },
  }
</script>